// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table{
  display:table;
}
.scroll{
  overflow:auto;
}

.dragPoint {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 20px;
    width: 20px;
    border-radius: 5px;
    background-color: gray;
    z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layouts/flex/flex.layout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB","sourcesContent":[".table{\n  display:table;\n}\n.scroll{\n  overflow:auto;\n}\n\n.dragPoint {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    height: 20px;\n    width: 20px;\n    border-radius: 5px;\n    background-color: gray;\n    z-index: 999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
